module.exports = __webpack_public_path__ + "static/img/order2.50e5639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/order2.png
// module id = 1249
// module chunks = 0